'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SiteConsumer = exports.Site = exports.SiteProvider = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

exports.withSite = withSite;
exports.useSite = useSite;

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _site = require('../utils/site');

var _site2 = _interopRequireDefault(_site);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HnContext = React.createContext(_site2.default);
var Consumer = HnContext.Consumer,
    Provider = HnContext.Provider;
// The site provider is the same as the 'Provider', but changes 'site' to
// 'value'.

var SiteProvider = exports.SiteProvider = function SiteProvider(_ref) {
    var site = _ref.site,
        children = _ref.children;
    return React.createElement(Provider, { value: site, children: children });
};
// The consumer is exported as both Site and SiteConsumer. The SiteConsumer can
// be used if also the Site from 'hn' is imported, so the names don't overlap.
exports.Site = Consumer;
exports.SiteConsumer = Consumer;
function withSite(Component) {
    var WrappedComponent = Component;
    return function ComponentWithSite(props) {
        return React.createElement(Consumer, null, function (site) {
            return React.createElement(WrappedComponent, (0, _assign2.default)({}, props, { site: site }));
        });
    };
}
function useSite() {
    // @ts-ignore
    return React.useContext(HnContext);
}
//# sourceMappingURL=site.js.map
